import { Button } from '@helios/ui';

export function SettingsDraftActions({ dirty, changedOnServer, onRevert, disabled }: { dirty: boolean; changedOnServer: boolean; onRevert: () => void; disabled?: boolean }) {
  if (!dirty && !changedOnServer) return null;
  return <div className="flex flex-wrap items-center gap-2 text-xs" role="status">
    <span className={changedOnServer ? 'text-warning' : 'text-muted-foreground'}>{changedOnServer ? 'A newer version is available. Your edits are preserved; review or revert before saving again.' : 'Unsaved changes'}</span>
    <Button type="button" size="xs" variant="outline" onClick={onRevert} disabled={disabled}>Revert to latest</Button>
  </div>;
}
